export default __webpack_public_path__ + "fca7a192cf45e8531d5e267d09efdaa7.png";